var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 118C18.7 118 15.874 116.826 13.522 114.478C11.174 112.126 10 109.3 10 106V22C10 18.7 11.174 15.874 13.522 13.522C15.874 11.174 18.7 10 22 10H58C59.7 10 61.126 10.574 62.278 11.722C63.426 12.874 64 14.3 64 16C64 17.7 63.426 19.124 62.278 20.272C61.126 21.424 59.7 22 58 22H22V106H106V70C106 68.3 106.576 66.874 107.728 65.722C108.876 64.574 110.3 64 112 64C113.7 64 115.124 64.574 116.272 65.722C117.424 66.874 118 68.3 118 70V106C118 109.3 116.826 112.126 114.478 114.478C112.126 116.826 109.3 118 106 118H22ZM46 82C44.9 80.9 44.35 79.5 44.35 77.8C44.35 76.1 44.9 74.7 46 73.6L97.6 22H82C80.3 22 78.876 21.424 77.728 20.272C76.576 19.124 76 17.7 76 16C76 14.3 76.576 12.874 77.728 11.722C78.876 10.574 80.3 10 82 10H112C113.7 10 115.124 10.574 116.272 11.722C117.424 12.874 118 14.3 118 16V46C118 47.7 117.424 49.124 116.272 50.272C115.124 51.424 113.7 52 112 52C110.3 52 108.876 51.424 107.728 50.272C106.576 49.124 106 47.7 106 46V30.4L54.25 82.15C53.15 83.25 51.8 83.8 50.2 83.8C48.6 83.8 47.2 83.2 46 82Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInExplorer);
export default __webpack_public_path__ + "static/media/open-in-explorer.5ff2bfd4e485dabe076988d28c47c41b.svg";
export { ForwardRef as ReactComponent };